import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaymentResponsePage } from './payment-response/payment-response.page';
import { PaymentTransferPage } from './payment-transfer/payment-transfer.page';
import { PaymentTypeComponent } from './payment-type/payment-type.component';

const routes: Routes = [
  {
    path: 'success',
    data: { success: true },
    component: PaymentResponsePage,
  },
  {
    path: 'error',
    data: { success: false },
    component: PaymentResponsePage,
  },
  {
    path: 'transfer/:inscriptionId',
    component: PaymentTransferPage,
  },
  {
    path: 'method/:inscriptionId',
    component: PaymentTypeComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CheckoutRoutingModule {}
